import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild
} from '@angular/core';

@Component({
    selector: 'unlock-slider',
    templateUrl: './unlock-slider.component.html',
    standalone: true,
    styleUrls: ['./unlock-slider.component.scss']
})
export class UnlockSliderComponent implements AfterViewInit {

  @Input() label: string = 'Desliza para abrir';
  @Output() unlocked = new EventEmitter<void>();

  @ViewChild('track', {static: true}) trackRef!: ElementRef<HTMLElement>;
  @ViewChild('handle', {static: true}) handleRef!: ElementRef<HTMLElement>;

  currentX = 0;
  private maxX = 0;
  private dragStartClientX = 0;
  private startX = 0;
  isDragging = false;
  isUnlocked = false;

  ngAfterViewInit(): void {
    const trackWidth = this.trackRef.nativeElement.offsetWidth;
    const handleWidth = this.handleRef.nativeElement.offsetWidth;
    this.maxX = trackWidth - handleWidth;
  }

  onDragStart(event: PointerEvent): void {
    if (this.isUnlocked) {
      return;
    }
    event.preventDefault();
    this.isDragging = true;
    this.dragStartClientX = event.clientX;
    this.startX = this.currentX;

    (event.target as HTMLElement).setPointerCapture(event.pointerId);
  }

  @HostListener('document:pointermove', ['$event'])
  onPointerMove(event: PointerEvent): void {
    if (!this.isDragging || this.isUnlocked) {
      return;
    }

    const delta = event.clientX - this.dragStartClientX;
    let newX = this.startX + delta;

    if (newX < 0) newX = 0;
    if (newX > this.maxX) newX = this.maxX;

    this.currentX = newX;
  }

  @HostListener('document:pointerup', ['$event'])
  onPointerUp(event: PointerEvent): void {
    if (!this.isDragging) return;

    this.isDragging = false;
    const threshold = this.maxX * 0.8;

    if (this.currentX >= threshold) {
      this.currentX = this.maxX;
      this.isUnlocked = true;
      this.unlocked.emit();

      setTimeout(() => {
        this.reset();
      }, 3000);
    } else {
      this.currentX = 0;
    }
  }

  reset(): void {
    this.isUnlocked = false;
    this.currentX = 0;
  }

}
